import { MultipleChoiceVotesList } from "./MultipleChoiceVotesList";

export default MultipleChoiceVotesList;